module.exports = {
  removeQueryParam(thiz, paramName) {
    let query = Object.assign({}, thiz.$route.query);
    delete query[paramName];
    thiz.$router.replace({ query });
  },
  routeToAccount(thiz) {
    thiz.$router.push({ name: "Subscription" });
  },
};
